// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__19geJ","footer":"ModalCreateQualiphyProcedure_footer__1p0HP","additionData":"ModalCreateQualiphyProcedure_additionData__1Wh4u"};